import { FileInfo, FileUploader } from 'br2s-ui-componentlibrary_r2_02';
import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { UploadService } from 'br2s-ui-common-utils-02';
import { CRM_FORM } from '@/services/api/crm/crm';

/* eslint-disable react/no-danger */
// istanbul ignore next
export const generateSession = async () => {
  try {
    await CRM_FORM.getSession();
  } catch (error) {
    throw error;
  }
};

// istanbul ignore next
function getErrorMsg(message: string): React.ReactNode {
  return (
    <div>
      <div
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      />
    </div>
  );
}

export const getInputState = (
  key: string,
  formError: Record<string, string>,
  isSubmitClicked: boolean
) => {
  const status = formError[key];
  if (status !== undefined && status !== '') {
    return 'error';
  }
  if (isSubmitClicked) {
    return 'success';
  }
  return 'default';
};

// istanbul ignore next
export function renderFileUploader(
  attachments: FileInfo[],
  setAttachments: React.Dispatch<React.SetStateAction<FileInfo[]>>
) {
  return (
    <FileUploader
      id="attachments"
      label="Attachments (Optional)"
      fileFormatsAccepted={['pdf', 'jpg', 'jpeg', 'png', 'xls', 'xlsx']}
      maxFileSizeInMB={2}
      maxFileNumbers={5}
      files={attachments}
      setFiles={setAttachments}
      handleUpload={(file) => UploadService.handleUpload(file, 'ez')}
      handleDelete={() => undefined}
    />
  );
}

export const isAttachmentsLoadingOrError = (attachments: any[]) =>
  attachments.some(
    (item) => item.status === 'loading' || item.status === 'error'
  );

export const modifyQueryParam = () => {
  let encryptedFormParam = window.location.search
    .substring(1)
    .replace(/%20/g, '');
  encryptedFormParam = encryptedFormParam.replace(/\+/g, '');
  encryptedFormParam = encryptedFormParam.replace(/\//g, '');
  return encryptedFormParam;
};

export const replaceEmptyStringWithNull = (string: string) => {
  if (string === '' || string === undefined) {
    return null;
  }

  return string;
};

dayjs.extend(utc);
dayjs.extend(timezone);

type IFormatDateOptions = {
  timeZone?: string;
  format?: string;
} | null;
/**
 * Convert date time string to 03 Jan 2023 format default. but able to pass the format if needed.
 * based on: https://www.npmjs.com/package/dayjs
 * @param dateString string
 * @param options IFormatDateOptions
 * @returns string
 */
// istanbul ignore next
export const formatDate = (
  dateString: string,
  options: IFormatDateOptions = null
): string => {
  const date = new Date(dateString);
  if (!Number.isNaN(date.getTime())) {
    return dayjs(date)
      .tz(options?.timeZone || 'Asia/Singapore')
      .format(options?.format || 'DD MMM YYYY');
  }
  return '';
};

export default getErrorMsg;
